module.exports = __webpack_public_path__ + "static/media/store-icon-details.57d530a2.png";